var _style, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndpackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2D3958;}\n\t.st1{fill:none;stroke:#2D3958;stroke-width:0.55;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.6,1.7h9.1l0,0.3l1,7.5v3.8c0,0.6-0.4,1-1,1H3.8c-0.5,0-1-0.5-1-1V9.5l0.3-3.8l0.7,0.1L3.5,9.5v3.7 c0,0.2,0.1,0.3,0.3,0.3h6.3V9.5l0.3-3.8l0.7,0.1l-0.3,3.7v4.1h2c0.2,0,0.3-0.2,0.3-0.3V9.6l-0.9-6.7l-1.3,1.5H2.3L3.6,1.7z  M11.7,2.4H4L3.4,3.7h7.2L11.7,2.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 7.1,
    className: "st1",
    width: 4,
    height: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndpackage);
export default __webpack_public_path__ + "static/media/indpackage.e0fcdbdafecec8e98fddefcdc94123af.svg";
export { ForwardRef as ReactComponent };